// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"fd7db618","331":"e322f6b3","519":"da401f6c","693":"d0e4b953"}[chunkId] + ".chunk.css";
};